import React, {useState} from 'react';
import { useSelector } from 'react-redux';
import {
  Card,
  Tab,
  Tabs,
} from '@material-ui/core';
import { BackdropCircular, Breadcrumb } from 'components';
import QuoteMarketingSegments from './QuoteMarketingSegments';
import SegmentsCustomersTable from './SegmentsCustomersTable';


const MarketingSegmentsTabs = () => {
  const [tabValue, setTabValue] = useState('marketing_segments');
  const { isEavAttributeLoading } = useSelector((state: IReduxState) => state.eavAttributes);
  const { isLoadingMarketingSegmentsCustomers, isLoadingEditCustomer } = useSelector((state: IReduxState) => state.quote_marketing_segments);
  const { updatingCustomerData } = useSelector((state: IReduxState) => state.customers);

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y pb-25">
      <div className="mb-sm-30">
        <Breadcrumb routeSegments={[{ name: 'Marketing Segments' }]} />
      </div>
      <Card className="mx-5 pt-8 root-card">
        <Tabs
          value={tabValue}
          onChange={(event, newValue) => setTabValue(newValue)}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab value="marketing_segments" label="Segments" />
          <Tab value="marketing_customers" label="Customers" />
        </Tabs>
        {tabValue === 'marketing_segments' && <QuoteMarketingSegments />}
        {tabValue === 'marketing_customers' && <SegmentsCustomersTable />}
        <BackdropCircular loading={isEavAttributeLoading || isLoadingMarketingSegmentsCustomers || isLoadingEditCustomer || updatingCustomerData} />
      </Card>
    </div>
  );
};

export default MarketingSegmentsTabs;
